import Vue from 'vue'
import Router from 'vue-router'

import conf from '../../../conf'

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch(err => err)
}
const router = new Router({
  mode: conf.routerMode,
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Default',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('../../../views/qyw/merchant/Login.vue')
    },
    {
      path: '/mains',
      name: 'Mains',
      redirect: '/home',
      component: () => import('../../../views/qyw/merchant/Mains.vue'),
      children: [
        {
          path: '/home',
          name: 'Home',
          component: () => import('../../../views/qyw/merchant/home/Home.vue'),
          meta: {
            title: '首页',
            keepAlive: true
          }
        },
        {
          path: '/summary',
          name: 'Summary',
          component: () => import('../../../views/qyw/merchant/summary/Summary.vue'),
          meta: {
            title: '订单汇总',
            keepAlive: true
          }
        },
        {
          path: '/order',
          name: 'Order',
          component: () => import('../../../views/qyw/merchant/order/Order.vue'),
          meta: {
            title: '订单流水',
            keepAlive: true
          }
        },
        {
          path: '/check',
          name: 'Check',
          component: () => import('../../../views/qyw/merchant/check/Check.vue'),
          meta: {
            title: '订单核准',
            keepAlive: true
          }
        },
        {
          path: '/download',
          name: 'Download',
          component: () => import('../../../views/qyw/merchant/download/Download.vue'),
          meta: {
            title: '账单下载',
            keepAlive: true
          }
        },
        {
          path: '/jhmorder',
          name: 'Jhmorder',
          component: () => import('../../../views/qyw/merchant/jhmorder/Jhmorder.vue'),
          meta: {
            title: '聚合码对账',
            keepAlive: true
          }
        },
        {
          path: '/bill',
          name: 'Bill',
          component: () => import('../../../views/qyw/merchant/bill/Bill.vue'),
          meta: {
            title: '聚合码管理',
            keepAlive: true
          }
        },
        {
          path: '/bills',
          name: 'Bills',
          component: () => import('../../../views/qyw/merchant/bill/Bills.vue'),
          meta: {
            title: '对账单管理',
            keepAlive: true
          }
        },
        {
          path: '/refund',
          name: 'Refund',
          component: () => import('../../../views/qyw/merchant/refund/Refund.vue')
        },
        /* eslint-disabled */
        {
          path: '/refund/detail',
          name: 'RefundDetail',
          component: () => import('../../../views/qyw/merchant/refund/RefundDetail.vue')
        },
        {
          path: '/orderDivide',
          name: 'OrderDivide',
          component: () => import('../../../views/qyw/merchant/orderDivide/OrderDivide.vue')
        },
        {
          path: '/orderDivide/detail',
          name: 'OrderDivideDetail',
          component: () => import('../../../views/qyw/merchant/orderDivide/OrderDivideDetail.vue')
        },
        {
          path: '/orderDivide/sum',
          name: 'SumOrderDivide',
          component: () => import('../../../views/qyw/merchant/orderDivide/SumOrderDivide.vue')
        },
        {
          path: '/cash',
          name: 'Cash',
          component: () => import('../../../views/qyw/merchant/cash/Cash.vue')
        },
        {
          path: '/shop',
          name: 'Shop',
          component: () => import('../../../views/qyw/merchant/shop/shop.vue')
        },
        {
          path: '/deviceConfig',
          name: 'DeviceConfig',
          component: () => import('../../../views/qyw/merchant/shop/deviceConfig.vue')
        },
        {
          path: '/assistant',
          name: 'Assistant',
          component: () => import('../../../views/qyw/merchant/assistant/Assistant.vue')
        },
        {
          path: '/department',
          name: 'Department',
          component: () => import('../../../views/qyw/merchant/department/Department.vue')
        },
        {
          path: '/code',
          name: 'Code',
          component: () => import('../../../views/qyw/merchant/code/Code.vue')
        },
        {
          path: '/remotePayCode',
          name: 'RemotePayCode',
          component: () => import('../../../views/qyw/merchant/remotePayCode/RemotePayCode.vue')
        },
        {
          path: '/invoice/list',
          name: 'InvoiceList',
          component: () => import('../../../views/qyw/merchant/invoice/InvoiceList.vue')
        },
        {
          path: '/invoice',
          name: 'Invoice',
          component: () => import('../../../views/qyw/merchant/invoice/Invoice.vue')
        },
        {
          path: '/member',
          name: 'Member',
          component: () => import('../../../views/qyw/merchant/member/Member.vue')
        },
        {
          path: '/member/apply',
          name: 'MemberApply',
          component: () => import('../../../views/qyw/merchant/member/MemberApply.vue')
        },
        {
          path: '/member/apply/success',
          name: 'MemberApplySuccess',
          component: () => import('../../../views/qyw/merchant/member/MemberApplySuccess.vue')
        },
        {
          path: '/member/apply/cancel',
          name: 'MemberApplyCancel',
          component: () => import('../../../views/qyw/merchant/member/MemberApplyCancel.vue')
        },
        {
          path: '/message',
          name: 'Message',
          component: () => import('../../../views/qyw/merchant/merchants/Message.vue')
        },
        {
          path: '/users',
          name: 'Users',
          component: () => import('../../../views/qyw/merchant/merchants/Users.vue')
        },
        {
          path: '/balance',
          name: 'Balance',
          component: () => import('../../../views/qyw/merchant/balance/Balance.vue')
        },
        {
          path: '/balance/detail',
          name: 'BalanceDetail',
          component: () => import('../../../views/qyw/merchant/balance/BalanceDetail.vue')
        }
      ]
    },
    {
      path: '/*',
      name: 'PageNotFound',
      component: () => import('../../../views/qyw/merchant/PageNotFound.vue')
    }
  ]
})

export default router
